import { FC, useCallback } from 'react';

import { MagritteBannerTitle } from 'components/common/MagritteBannerTitle/MagritteBannerTitle';

import { setBannerTitle } from 'store/models/createBanner';
import { useDispatch, useSelector } from 'store/utils';

export const BannerTitle: FC = () => {
    const { bannerTitle, bannerErrors } = useSelector((state) => state.createBanner);

    const dispatch = useDispatch();

    const onChange = useCallback(
        (value: string) => {
            dispatch(setBannerTitle(value));
        },
        [dispatch]
    );

    return (
        <MagritteBannerTitle
            value={bannerTitle}
            onChange={onChange}
            error={bannerErrors.bannerTitle}
            vSpacingBottom={32}
            dataQa="flexible-title-input"
        />
    );
};
